import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { GitBranchCompareModel } from '@common/git/models/git-branch-compare.model';
import { PageFilter } from '@common/paged-data/types/page-filter.type';
import { Page } from '@common/paged-data/types/page.type';
import { ApiService } from '@portal-core/auth/services/api.service';
import { Branch } from '@portal-core/branches/models/branch.model';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable, map } from 'rxjs';

@Service()
export class BranchesApiService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);

  @SharePendingRequest()
  getBuildBranchesPageByProjectId$(projectId: number, filter: PageFilter): Observable<Page<Branch>> {
    return this.http.post<Page<Branch>>(`${this.apiService.centralApiBaseUri}/api/projects/${projectId}/branchnames`, filter);
  }

  @SharePendingRequest()
  getProjectBranches$(projectId: number): Observable<string[]> {
    return this.http.get<Branch[]>(`${this.apiService.centralApiBaseUri}/api/projects/${projectId}/Branches`).pipe(
      map(branches => branches.map(branch => branch.Name))
    );
  }

  @SharePendingRequest()
  getProjectBranchesPageByProjectId$(projectId: number, filter: PageFilter): Observable<Page<Branch>> {
    return this.http.post<Page<Branch>>(`${this.apiService.centralApiBaseUri}/api/projects/${projectId}/BranchesGrid`, filter);
  }

  @SharePendingRequest()
  getDefaultBranch$(projectId: number): Observable<Branch> {
    return this.http.get<Branch>(`${this.apiService.centralApiBaseUri}/api/git/projects/${projectId}/DefaultBranch`);
  }

  @SharePendingRequest()
  getBranchFromProjectId$(projectId: number, branchName: string): Observable<Branch> {
    return this.http.get<Branch>(`${this.apiService.centralApiBaseUri}/api/git/projects/${projectId}/branches/${encodeURIComponent(branchName)}`);
  }

  @SharePendingRequest()
  createBranch$(projectId: number, sourceBranch: string, name: string): Observable<Branch> {
    return this.http.post<Branch>(`${this.apiService.centralApiBaseUri}/api/git/projects/${projectId}/branches/create`, {sourceBranch: sourceBranch, name: name});
  }

  @SharePendingRequest()
  deleteBranches$(projectId: number, branchNames: string[]): Observable<void> {
    return this.http.post<void>(`${this.apiService.centralApiBaseUri}/api/git/projects/${projectId}/branches/delete`, branchNames);
  }

  @SharePendingRequest()
  compareBranches$(projectId: number, fromBranchName: string, toBranchName: string): Observable<GitBranchCompareModel> {
    return this.http.get<GitBranchCompareModel>(`${this.apiService.centralApiBaseUri}/api/git/projects/${projectId}/branches/compare?from=${encodeURIComponent(fromBranchName)}&to=${encodeURIComponent(toBranchName)}`);
  }
}
